var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellPriceChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.5337C18.4889 29.0448 17.8556 29.3003 17.1 29.3003C16.3445 29.3003 15.7111 29.0448 15.2 28.5337L3.46669 16.8003C3.22225 16.5559 3.02758 16.267 2.8827 15.9337C2.73781 15.6003 2.66581 15.2448 2.6667 14.867V5.33366C2.6667 4.60033 2.92803 3.97277 3.4507 3.45099C3.97336 2.92921 4.60092 2.66788 5.33336 2.66699H14.8667C15.2445 2.66699 15.6 2.73944 15.9334 2.88433C16.2667 3.02921 16.5556 3.22344 16.8 3.46699L28.5334 15.2337C29.0445 15.7448 29.3 16.3728 29.3 17.1177C29.3 17.8625 29.0445 18.4901 28.5334 19.0003L19 28.5337ZM8.6667 10.667C9.22225 10.667 9.69469 10.4728 10.084 10.0843C10.4734 9.69588 10.6676 9.22344 10.6667 8.66699C10.6658 8.11055 10.4716 7.63855 10.084 7.25099C9.69647 6.86344 9.22403 6.66877 8.6667 6.66699C8.10936 6.66521 7.63736 6.85988 7.2507 7.25099C6.86403 7.6421 6.66936 8.1141 6.6667 8.66699C6.66403 9.21988 6.8587 9.69233 7.2507 10.0843C7.6427 10.4763 8.1147 10.6705 8.6667 10.667Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellPriceChange);
export default __webpack_public_path__ + "static/media/sell_price_change.ea82e4ce054b2e135732fefedb4e570e.svg";
export { ForwardRef as ReactComponent };